<template>
    <div>
        <file-item
                v-if="hasValue"
                removable
                :metadata="metadata"
                :url="url"
                :key="url"
                @remove="emit(null)"
        />
        <file-source v-else @input="emit"/>
    </div>
</template>

<script>
  import FileItem from './file-item';
  import FileSource from './file-source';

  export default {
    components: {
      FileItem,
      FileSource,
    },

    props: {
      value: {
        type: File,
      },
    },

    data() {
      return {
        url: null,
      }
    },

    computed: {
      /**
       * @return {boolean}
       */
      hasValue() {
        return Boolean(this.value);
      },

      /**
       * @return {object}
       */
      metadata() {
        return !this.value
          ? null
          : {
            filename: this.value.name,
            size: this.value.size,
            type: this.value.type,
          };
      },
    },

    watch: {
      value(val) {
        this.revokeFileUrl();
        this.createFileUrl(val);
      },
    },

    methods: {
      /**
       * @emits input
       */
      emit(val) {
        this.$emit('input', val);
      },

      /**
       * @param {File} file
       */
      createFileUrl(file) {
          this.url = file ? URL.createObjectURL(file) : null;
      },

      /**
       * @return {undefined}
       */
      revokeFileUrl() {
        this.url && URL.revokeObjectURL(this.url);
      }
    },

    beforeDestroy() {
      this.revokeFileUrl();
    }
  }
</script>
